import type { Nullable } from "src/types.js";

export function getMetaTagContent(metaTagName: string) {
  try {
    const selector = `meta[name='${metaTagName}']`;
    let element: Nullable<HTMLMetaElement> = document.querySelector(selector) as HTMLMetaElement;
    if (!element) {
      element = window.top?.document.querySelector(selector);
    }
    return element?.content;
  } catch (e) {
    return undefined;
  }
}

export function parseMetaTag(metaTagName: string) {
  const content = getMetaTagContent(metaTagName);
  if (content) {
    return JSON.parse(content);
  } else {
    throw new Error(`failed to parse meta tag ${metaTagName}`);
  }
}
